import React from 'react';
import { IconName, IconPrefix } from '@fortawesome/fontawesome-common-types';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Icon: React.FC<{
  icon: IconName;
  type?: IconPrefix;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  size?: SizeProp;
}> = ({ icon, type = 'fal', className, style, onClick, size }) => (
  <FontAwesomeIcon
    icon={[type, icon]}
    className={className || 'icon'}
    style={style}
    onClick={onClick}
    size={size}
  />
);
